import { Weekdays } from "../../../../Pickers/WeekdayPicker/weekday-picker.component";

export const areDaysEqual = (a: Weekdays | undefined, b: Weekdays): boolean => {
  if (!a) return false;

  return (Object.keys(b) as (keyof Weekdays)[]).every(day => a[day] === b[day]);
};
